<div class="user-menu" tid="user-action-menu">
  <ng-container *ngIf="profile$ | async as profile">
    <button
      type="button"
      class="user-menu__trigger"
      tid="user-action-menu-trigger"
      [attr.aria-expanded]="menuOpen"
      [attr.aria-haspopup]="true"
      (click)="toggleMenu($event)"
    >
      <span class="user-menu__avatar" [attr.aria-label]="'Signed in as ' + profile.email">
        <app-body [ink]="'ink-white'">{{ profile.initials }}</app-body>
      </span>
    </button>

    <div class="user-menu__panel" *ngIf="menuOpen" role="menu">
      <div class="user-menu__signed-in">
        <app-body-xs class="user-menu__signed-in-label">Signed in as</app-body-xs>
        <app-body class="user-menu__email">{{ profile.email || '—' }}</app-body>
      </div>
      <div class="user-menu__divider" role="presentation"></div>
      <button type="button" class="user-menu__sign-out" tid="logout-button" role="menuitem" (click)="signOut()">
        <app-icon class="user-menu__sign-out-icon" [size]="'small'" [color]="'system-red'">logout</app-icon>
        <app-body>Sign out</app-body>
      </button>
    </div>
  </ng-container>
</div>
